import type * as Core from "@zeller-public/payments-sdk-core";
import type { z } from "zod";

import type { PurchaseResponseSchema } from "../terminal-purchase/schemas";
import type { RefundResponseSchema } from "../terminal-refund/shared/schemas";

export function ProtocolTransaction_fromPosConnectorResponse(
	data: z.infer<typeof PurchaseResponseSchema>["data"] &
		z.infer<typeof RefundResponseSchema>["data"],
): Omit<Core.Protocol.Transaction, "$type" | "type" | "externalReference"> {
	return {
		// mandatory
		amount: data.amount,
		caid: data.caid,
		catid: data.catid,
		currency: data.currency ?? "AUD",
		responseCode: data.responseCode,
		responseText: data.responseText,
		status: data.status,
		timestampLocal: data.timestampLocal ?? new Date().toISOString(),
		transactionUuid: data.transactionUuid,

		// optional
		aid: data.aid,
		applicationName: data.applicationName,
		approvalCode: data.authCode,
		bin: data.bin,
		cardMedia: data.cardMedia,
		cardholderUuid: data.cardholderUuid,
		cvm: data.cvm,
		emvTagsPrint: data.emvTagsPrint,
		panMasked: data.panMasked,
		receiptLink: data.receiptLink,
		receiptText: data.receiptText,
		rrn: data.rrn,
		scheme: data.scheme,
		sessionUuid: data.sessionUuid,
		surchargeAmount: data.surchargeAmount,
		taxAmount: data.taxAmount,
		tipAmount: data.tipAmount,
	};
}
